export default __webpack_public_path__ + "static/media/dish-example.89240e93.jpg";